import { render } from "./RegionFilter.vue?vue&type=template&id=221d3c90&scoped=true&ts=true"
import script from "./RegionFilter.ts?vue&type=script&lang=ts"
export * from "./RegionFilter.ts?vue&type=script&lang=ts"

import "./RegionFilter.scss?vue&type=style&index=0&id=221d3c90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221d3c90"]])

export default __exports__